import { isFunction } from 'swipeclock-frontend';

export const WEB_CLOCK_JWT_REFRESH_RESULT_EVENT = 'webClockJwtRefreshResult';

const hasIosRefreshBridge = () =>
  isFunction(window?.webkit?.messageHandlers?.webClockRefreshJwt?.postMessage);

const hasAndroidRefreshBridge = () =>
  isFunction(window?.AndroidNative?.refreshWebClockJwt);

export const hasJwtRefreshBridge = () =>
  hasIosRefreshBridge() || hasAndroidRefreshBridge();

/**
 * Asks the native app for a fresh JWT. Success reloads WebClock with the new
 * token. Failure is reported through webClockJwtRefreshResult with
 * { status: 'failed' }.
 *
 * @returns {boolean} true when a native bridge received the request
 */
export const requestJwtRefresh = () => {
  if (hasIosRefreshBridge()) {
    window.webkit.messageHandlers.webClockRefreshJwt.postMessage(null);
    return true;
  }
  if (hasAndroidRefreshBridge()) {
    window.AndroidNative.refreshWebClockJwt();
    return true;
  }
  return false;
};
